import Inputmask from 'inputmask';

// require('inputmask/dist/jquery.inputmask');
require('inputmask/dist/bindings/inputmask.binding');

Inputmask.extendDefaults({
  'autoUnmask': true,
  'removeMaskOnSubmit': true
});